export default __webpack_public_path__ + "static/media/logo.fc19a57e.png";